export enum PageType {
    EmailPage = 1,
    CartPage = 2,
    Conversion = 3
}
